import { useState } from 'react';

export const CreditButton = () => {
  const [showCreditLabel, setShowCreditLabel] = useState(false);

  return (
    <>
      {showCreditLabel && (
        <div
          className="fixed inset-0"
          onClick={() => setShowCreditLabel(false)}
        />
      )}
      <div className="z-40 fixed bottom-[45px] pc:bottom-[70px] right-[1%] flex flex-col items-end gap-1">
        {showCreditLabel && (
          <a
            href={`${import.meta.env.VITE_DIGITANE_URL}credit/`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white font-bold text-sm pc:text-base bg-black/50 rounded px-2 py-1 hover:opacity-70 transition-opacity whitespace-nowrap underline"
            onClick={(e) => e.stopPropagation()}
          >
            クレジット
          </a>
        )}
        <button
          className="text-white hover:opacity-70 transition-opacity"
          onClick={() => setShowCreditLabel((prev) => !prev)}
          aria-label="クレジット情報"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-8 h-8 pc:w-10 pc:h-10"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
            />
          </svg>
        </button>
      </div>
    </>
  );
};
